import { db } from '../db';

/**
 * Custom async storage adapter for Supabase auth.
 * Uses Dexie (IndexedDB) instead of localStorage for offline persistence.
 */
export const dexieStorageAdapter = {
  async getItem(key: string): Promise<string | null> {
    const row = await db.authStore.get(key);
    return row?.value ?? null;
  },
  async setItem(key: string, value: string): Promise<void> {
    await db.authStore.put({ key, value });
  },
  async removeItem(key: string): Promise<void> {
    await db.authStore.delete(key);
  },
};
